<template>
  <div class="vw100 vh100 flex-box flex-col al-c ju-c">
    <div class="w100">
      <div class="w120 mc flex-box al-c">
        <div class="flex-1" style="height: 74px">
          <img class="logo" v-show="getConfig.logo" :src="getConfig.logo">
        </div>
      </div>
    </div>
    <div class="w100 mt10 login-wrapper flex-box ju-c" :style="{ 'background-image': `url(${baseUrl}images/login-bg.png)` }">
      <div class="flex-box al-c login-main" :style="{ 'background-image': `url(${baseUrl}images/login-main-bg.png)` }">
        <div class="flex-1 pl20 pr20 ml20">
          <img :src="`${baseUrl}images/login-title1.png`">
        </div>
        <div class="login-view">
          <el-form :model="formInline" status-icon :rules="rules" ref="ruleForm" label-width="100px">
          <p class="pb10 tx-c" style="color: #666666; font-size:26px">办事大厅</p>
          <div class="w100 mt20 pl5 pr5">
            <el-input size="large" class="username-input" v-model="username" clearable  placeholder="请输入用户名">
              <div slot="prefix" style="height:40px;width:40px;background-color:#218DEE">
                <i class="el-icon-user"></i>
              </div>
            </el-input>
          </div>
          <el-form-item label="" prop="code">
          <div class="w100 mt20 pl5 pr5 cl-f">
            <el-input size="large" class="verify-input fl" v-model="formInline.code"  placeholder="请输入验证码">
              <div slot="prefix" style="height:40px;width:40px;background-color:#218DEE">
                <i class="el-icon-discount"></i>
              </div>
            </el-input>
            <el-button type="primary" class="get_code_btn fl" :disabled="!username" @click="sendPwdCodeHandle" v-if="!isCodeing">获取验证码</el-button>
            <div class="get_code_btn timer fl" v-if="isCodeing"><span>{{count}}s</span> 后重新获取</div>
          </div>
            </el-form-item>
            <el-form-item label="" prop="password">
          <div class="w100 mt20 pl5 pr5">
            <el-input size="large" class="password-input" auto-complete="new-password" type="password" v-model="formInline.password" @keyup.enter.native="handleSubmit" clearable show-password placeholder="请输入密码">
              <div slot="prefix" style="height:40px;width:40px;background-color:#218DEE">
                <i class="el-icon-lock"></i>
              </div>
            </el-input>
          </div>
            </el-form-item>
          <div class="w100 mt20 pl5 pr5 flex-box">
            <div class="flex-1">
            </div>
            <router-link class="cu-p" :to="'/login'" style="color:#9A9898">去登录</router-link>
          </div>
          <div class="w100 mt20 pb20 pl5 pr5">
            <el-button class="w100" size="large" type="primary" :disabled="requesting||!formInline.code||!formInline.password" :loading="requesting" @click="submitForm" >提 交</el-button>
          </div>
            </el-form>
        </div>
      </div>
    </div>
    <!--<div class="w100 tx-c grey font-14" style="line-height:40px">技术支持：南宁市迈越软件有限公司</div>-->
    <!-- 验证码弹窗 -->
    <el-dialog
      title="验证码"
      :visible.sync="codeDialog"
      width="30%"
      @close="handleClose">
      <el-row>
        <el-col :span="12">
          <el-input v-model="code" placeholder="请输入验证码" style="line-height:50px"></el-input>
        </el-col>
        <el-col :span="12" style="text-align:center">
          <el-image
            width="170"
            height="50"
            :src="`/hallportal/code?randomStr=${randomStr}`"
            alt="验证码"
            title="点击切换验证码"
            @click="initCode"
          />
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="codeDialog = false">取 消</el-button>
        <el-button type="primary" @click="codeSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
    import { generateCodeVerifier,checkCode } from "@/util/utils";
    import {resetPwdByCode,sendPwdCode,getLoginConfig} from "@/api/login";
    import request from '@/util/http'
    export default {
        name: "ForgetPassword",
        components: {},
        data() {
            return {
                baseUrl: process.env.BASE_URL,
                getConfig:{},
                isCodeing:false,
                count:0,
                username:'',
                loading: false,
                requesting:false,
                formInline: {
                  password: "",
                  code: "",
                },
                rules: {
                    password: [
                        { min: 6, max: 20, message: "长度在 6 到 20 个字符", trigger: "change" }
                    ]
                },
                codeDialog:false,
                randomStr: "", //验证码
                code: "",
            };
        },
        computed: {
        },
        created() {

        },
        mounted() {
          this.initCode();
          this.getLoginConfig();
        },

        methods: {
            submitForm() {
                this.$refs.ruleForm.validate(valid => {
                    if (valid) {
                        this.resetPwdByCodeHandle();
                    }
                });
            },

            resetPwdByCodeHandle(){
                this.requesting=true;
                resetPwdByCode({...this.formInline,secPassword:this.formInline.password,username:this.username}).then(({data})=>{
                    this.requesting=false;
                    if(data.code==0){
                        this.$message.success('修改密码成功，3秒后跳入登录页');
                        setTimeout(()=>{
                            this.$router.push('/login');
                        },3000)
                    }else{
                        this.$message.warning(data.msg||'修改密码失败!');

                    }
                }).catch(err=>{
                    this.requesting=false;
                })

            },

            sendPwdCodeHandle(){
              this.codeDialog=true;
              // return
              //   sendPwdCode(this.username).then(({data})=>{
              //       if(data.code==0){
              //           this.getVerifyCode();
              //           this.formInline.userId=data.data.userId;
              //       }else{
              //           this.$message.warning(data.msg||'短信发送失败!');
              //       }
              //   }).catch(err=>{
              //   })

            },

            getVerifyCode(){
                const TIME_COUNT = 60;
                if (!this.timer) {
                    this.count = TIME_COUNT;
                    this.isCodeing = true;
                    this.timer = setInterval(() => {
                        if (this.count > 0 && this.count <= TIME_COUNT) {
                            this.count--;
                        } else {
                            this.isCodeing = false;
                            clearInterval(this.timer);
                            this.timer = null;
                        }
                    }, 1000)
                }

            },
            async getLoginConfig() {
              let res = await getLoginConfig();
              res.data.data.isOpenCassso == "1"
                ? (res.data.data.isOpenCassso = true)
                : (res.data.data.isOpenCassso = false);
              res.data.data.middlePage == "1"
                ? (res.data.data.middlePage = true)
                : (res.data.data.middlePage = false);
              res.data.data.phone == "1"
                ? (res.data.data.phone = true)
                : (res.data.data.phone = false);
              res.data.data.mobileOrPc == "1"
                ? (res.data.data.mobileOrPc = true)
                : (res.data.data.mobileOrPc = false);
              this.phoneBlo = res.data.data.phone;
              this.getConfig = res.data.data;
              window.sessionStorage.setItem(
                "setConfig",
                JSON.stringify(this.getConfig)
              );
              let faviconLink = document.querySelector("#faviconLink");
              if (faviconLink) {
                faviconLink.setAttribute("href", this.getConfig.favicon);
              }
            },
          initCode() {
            this.randomStr = generateCodeVerifier(5);
          },
          handleClose(){
            this.code=""
          },
          codeSubmit(){
            checkCode(`/check?code=${this.code}&randomStr=${this.randomStr}`).then(
              res => {
                if (res.data.success) {
                  this.seedCodeHandle();
                } else {
                  this.$Notify({ type: "danger", message: res.data.msg });
                }
              }
            );
          },
          seedCodeHandle(){
            request({
              url:`/admin/mobile/sendPwdCode/${this.username}?code=${this.code}&randomStr=${this.randomStr}`,
              method:'get'
            }).then(res=>{
              console.log(res)
              if(res.data.success){
                this.codeDialog=false
                this.getVerifyCode();
              }
            })
          }
        },
        destroyed() {},

        filters: {},
    };
</script>

<style scoped lang="less">
  /deep/div.el-form-item{
    margin-bottom: 0px!important;
  }
  /deep/div.el-form-item__content{
    margin-left: 0px!important;
  }
  .login-wrapper {
    height: 680px;
    background: #368ae2 center bottom no-repeat;
  }

  .login-main {
    margin-top: 60px;
    width: 900px;
    height: 430px;
    background: #fff right bottom no-repeat;
    box-shadow: 0 0 12px 10px #327cca;
  }

  .login-view {
    margin-right: 40px;
    width: 350px;
    padding: 20px 0 0 40px;
    border-left: 1px solid #ddd;
  }
  .username-input,.verify-input,.password-input {
    line-height: 40px;
    /deep/ .el-input__inner:not(.code-input) {
      border-radius: 0;
      text-indent: 20px;
      background-color: #F2F4F4;
    }
    /deep/ .el-input__prefix {
      left: 0;
      color: #fff;
      font-size: 18px;
    }
  }
  .verify-input {
    width: 185px;
  }
  .code-img {
    height: 40px;
    width: 140px;
    cursor: pointer;
  }
  .logo{
    height: 60px;
    margin-top: 10px;
  }
  .get_code_btn{
    width: 50px;
    width: 101px;
    margin-left: 10px;
    height: 40px;
    border-radius: 0px;
    &.timer{
      color: #595B5D;
      background: #F2F4F4;
     line-height: 40px;
      text-align: center;
      font-size: 12px;
      >span{
        color: #2BA246;
        font-weight: bold;
      }
    }

  }
</style>
